import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://rukenalazdehar.ae";
const DEFAULT_OG_IMAGE = "https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

/**
 * Per-page SEO helper.
 * Props:
 *  - title: page title (will be suffixed with brand)
 *  - description: meta description
 *  - path: URL path (starts with /). If omitted, canonical uses current location.
 *  - image: OG image URL
 *  - noindex: boolean
 *  - jsonLd: optional JSON-LD schema object (or array)
 */
export default function SEO({ title, description, path, image, noindex = false, jsonLd }) {
  const fullTitle = title
    ? `${title} | Ruken Alazdehar General Trading LLC`
    : "Ruken Alazdehar General Trading LLC | Global Network — Local Delivery";
  const desc =
    description ||
    "Ruken Alazdehar General Trading LLC — Dubai-based global trading house for strategic sourcing and distribution of industrial raw materials.";
  const url = path ? `${SITE}${path}` : (typeof window !== "undefined" ? window.location.href : SITE);
  const ogImage = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow, max-image-preview:large" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ruken Alazdehar General Trading LLC" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
